import { useTranslation } from 'i18n';
import { Box, Divider, PdfViewer, styled } from 'ui';

import { useDocument } from '../../context/DocumentContext';
import { ActionButtons } from '../ActionButtons/ActionButtons';
import { Header } from '../Header/Header';
import { NoDocument } from '../NoDocument/NoDocument';

const StretchedPdfViewer = styled(PdfViewer)(({ theme }) => ({
  flex: 1,
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
}));

export const DocumentDetails = () => {
  const { t } = useTranslation('orders');
  const { fileUrl } = useDocument();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <Header />
      <Divider />
      <ActionButtons />
      {fileUrl !== null ? (
        <StretchedPdfViewer title={t('documentGeneration.documentDetails.viewerTitle')} src={fileUrl} />
      ) : (
        <NoDocument />
      )}
    </Box>
  );
};
